import styled from '@emotion/styled';

const InviteContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;

export { InviteContainer };
